// assets/db-activity-page.js
(() => {
  const API_BASE = window.GD_API_BASE || 'https://gear-db-proxy.onrender.com';
  const GEAR_DB_PATH = '/pages/geardb';

  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]));
  const timeAgo = (input) => { const d=new Date(input), s=((Date.now()-d)/1000)|0;
    if(s<5)return'just now'; if(s<60)return s+'s ago'; const m=(s/60)|0; if(m<60)return m+'m ago';
    const h=(m/60)|0; if(h<24)return h+'h ago'; const dd=(h/24)|0; if(dd===1)return'yesterday';
    if(dd<7)return dd+'d ago'; const w=(dd/7)|0; if(w<5)return w+'w ago'; const mo=(dd/30)|0; if(mo<12)return mo+'mo ago'; const y=(dd/365)|0; return y+'y ago'; };
  const iconFor = (k, sub) => k==='comment'?'💬':k==='review'?'★':(sub==='👎'?'👎':'👍');

    const escapeHtml = (s) => String(s ?? '').replace(/[&<>"]/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]));
    const nl2br = (s) => escapeHtml(s).replace(/\n/g, '<br>');
    function scoreChips(it){
    const keys = ['surface','base','performance','comfort','durability'];
    const chips = keys.filter(k => typeof it[k] === 'number').map(k => `<span class="af-chip">${k}: ${it[k]}/5</span>`);
    return chips.length ? `<div class="af-chips">${chips.join('')}</div>` : '';
    }

  function linkToGearDb(it){
    const q = new URLSearchParams();
    if (it.product_handle) q.set('handle', it.product_handle);
    const t = it.kind === 'reaction' ? 'comment' : it.kind;
    if (it.id) q.set('focus', `${t}:${it.id}`);
    if (it.at) q.set('focusAt', it.at);
    if (it.text) q.set('focusText', it.text.slice(0,120));
    return `${GEAR_DB_PATH}?${q.toString()}`;
  }

  const state = { all: [], filtered: [], page: 0, pageSize: 20, kind: 'all', loaded: false };

  function render() {
    const root = document.getElementById('af-list');
    if (!root) return;
    const end = (state.page + 1) * state.pageSize;
    const items = state.filtered.slice(0, end);

    if (!state.loaded) { root.innerHTML = `<div class="af-empty">Loading…</div>`; return; }
    if (!items.length) { root.innerHTML = `<div class="af-empty">No activity yet.</div>`; return; }

    root.innerHTML = items.map(it => {
      const title = it.product_title || `Product ${it.product_id||''}`;
        const kindLabel = it.kind==='reaction' ? `reaction ${it.subtype||''}` : it.kind;
        const contentHtml = (it.text && it.text.trim()) ? nl2br(it.text.trim()) : '';
        const titleHtml = (it.kind === 'review' && it.title) ? `<div class="af-subtitle">${escapeHtml(it.title)}</div>` : '';
        const chipsHtml = (it.kind === 'review') ? scoreChips(it) : '';
        return `
        <a class="af-row" href="${linkToGearDb(it)}" target="_blank" rel="noopener">
            ${it.product_image_url ? `<img class="af-thumb" src="${escapeHtml(it.product_image_url)}" alt="">` : `<div class="af-thumb"></div>`}
            <div class="af-main">
            <div class="af-top">
                <span class="af-title">${escapeHtml(title)}</span>
                <span class="af-kind">${iconFor(it.kind, it.subtype)} ${escapeHtml(kindLabel)}</span>
                <span class="af-meta" title="${escapeHtml(new Date(it.at).toLocaleString())}">${escapeHtml(timeAgo(it.at))}</span>
            </div>
            ${titleHtml}
            ${chipsHtml}
            ${contentHtml ? `<div class="af-text">${contentHtml}</div>` : ''}
            </div>
        </a>`;
    }).join('');

    const moreBtn = document.getElementById('af-more');
    if (moreBtn) moreBtn.style.display = state.filtered.length > items.length ? '' : 'none';
  }

  function applyFilter(kind){
    state.kind = kind;
    state.page = 0;
    state.filtered = kind === 'all' ? state.all : state.all.filter(x => x.kind === kind);
    document.querySelectorAll('.gd-ap-filters button').forEach(b=>b.classList.toggle('on', b.dataset.kind === kind));
    render();
  }

  async function loadLatest(){
    try {
      const res = await fetch(`${API_BASE}/activity/latest?limit=200`, { cache: 'no-store' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
    state.all = Array.isArray(data?.items) ? data.items : [];
    state.loaded = true;
    updateFilterCounts(state.all);
    applyFilter(state.kind);
    } catch (e) {
      state.loaded = true;
      state.all = [];
      console.warn('[activity-page] load failed', e);
      render();
    }
  }

  function updateFilterCounts(list){
  const counts = { all: list.length, comment: 0, review: 0, reaction: 0 };
  for (const it of list) counts[it.kind] = (counts[it.kind]||0) + 1;
  document.querySelectorAll('.gd-ap-filters button').forEach(b=>{
    const k = b.dataset.kind;
    const base = b.textContent.replace(/\s+\(\d+\)$/, '');
    b.textContent = `${base} (${counts[k] ?? 0})`;
    b.disabled = (counts[k] ?? 0) === 0;
  });
}


  // Styles
  (function injectCSS(){
    if (document.getElementById('gd-activity-page-css')) return;
    const s = document.createElement('style');
    s.id = 'gd-activity-page-css';
    s.textContent = `
      .gd-activity-page{max-width:960px;margin:24px auto;padding:0 16px;font:400 16px/1.4 system-ui,Segoe UI,Roboto,Ubuntu,sans-serif}
      .gd-ap-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px}
      .gd-ap-filters{display:flex;gap:8px}
      .gd-ap-filters button{border:1px solid #e5e7eb;background:#fff;border-radius:999px;padding:6px 10px;cursor:pointer}
      .gd-ap-filters button.on{background:#111827;color:#fff;border-color:#111827}
      .gd-ap-list{display:flex;flex-direction:column;border:1px solid #e5e7eb;border-radius:14px;overflow:hidden}
      .af-row{display:flex;gap:12px;padding:12px;text-decoration:none;color:inherit;border-bottom:1px solid #f1f5f9}
      .af-row:last-child{border-bottom:0}
      .af-thumb{width:56px;height:56px;border-radius:8px;object-fit:cover;background:#f3f4f6;flex:0 0 auto}
      .af-main{min-width:0;flex:1}
      .af-top{display:flex;gap:8px;align-items:center}
      .af-title{font-weight:700}
      .af-kind{font-size:12px;padding:2px 6px;border:1px solid #e5e7eb;border-radius:999px;background:#fff;color:#374151;margin-left:auto}
      .af-meta{font-size:12px;color:#6b7280;margin-left:8px}
      .af-text{margin-top:4px;color:#111827;overflow-wrap:anywhere}
      .af-empty{padding:24px;color:#6b7280;text-align:center}
      .gd-ap-actions{display:flex;justify-content:center;margin-top:12px}
      #af-more{border:1px solid #e5e7eb;background:#fff;border-radius:8px;padding:8px 12px;cursor:pointer}
      .af-subtitle{margin-top:2px;font-weight:600;color:#111827}
      .af-chips{margin-top:4px;display:flex;flex-wrap:wrap;gap:6px}
      .af-chip{font-size:12px;border:1px solid #e5e7eb;border-radius:999px;padding:2px 6px;background:#fff;color:#374151}
      .af-text{margin-top:6px;color:#111827;overflow-wrap:anywhere}
    `;
    document.head.appendChild(s);
  })();

  function init(){
    document.querySelector('.gd-ap-filters')?.addEventListener('click', (e)=>{
      const b = e.target.closest('button[data-kind]'); if (!b) return;
      applyFilter(b.dataset.kind);
    });
    document.getElementById('af-more')?.addEventListener('click', ()=>{ state.page += 1; render(); });
    loadLatest();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
